import { layout34, layout34Components } from './v34/layout';
import { layout40, layout40Components } from './v40/layout';

export enum SchemaDictionaryNames {
	'InspectionReport:3.4' = 'v34',
	'InspectionReport:4' = 'v40'
}

export const LAYOUTS = {
	'v34': layout34,
	'v40': layout40
};

export const COMPONENTS = {
	'v34': layout34Components,
	'v40': layout40Components
}